var map = {
	"./decorate_unit_activity.png": "51f7",
	"./decorate_unit_banner.png": "44c2",
	"./decorate_unit_cell_icon.png": "88f8",
	"./decorate_unit_cell_icon2.png": "7963",
	"./decorate_unit_channel_banner.png": "ebaf",
	"./decorate_unit_code.png": "39c9",
	"./decorate_unit_coupon.png": "cbfd",
	"./decorate_unit_img_advert.png": "bcd6",
	"./decorate_unit_link_area.png": "31e6",
	"./decorate_unit_live_list.png": "9e02",
	"./decorate_unit_product.png": "efcf",
	"./decorate_unit_product_list.png": "2b77",
	"./decorate_unit_product_recommend.png": "60a7",
	"./decorate_unit_roll_icon.png": "f871",
	"./decorate_unit_separator.png": "8a11",
	"./decorate_unit_title.png": "d3e9",
	"./decorate_unit_update.png": "dac1",
	"./decorate_unit_video.png": "7399"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7aa7";